import { render } from "./openDoor.vue?vue&type=template&id=2388f4bc&scoped=true"
import script from "./openDoor.vue?vue&type=script&lang=js"
export * from "./openDoor.vue?vue&type=script&lang=js"

import "./openDoor.vue?vue&type=style&index=0&id=2388f4bc&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2388f4bc"]])

export default __exports__